import Layout from "../../../components/Layout";
import showFeedback from "../ShowFeedback";

export default function ShowFeedback() {
  return Layout(showFeedback, "Visualização do Feedback Semanal");
}
